import { Dispatch, useEffect, useState } from 'react';
import { CreateTaskInventory } from '@bringg/types';
import faker from 'faker';

import { useMerchant } from 'Providers';

export function useInventories(): [CreateTaskInventory[], Dispatch<CreateTaskInventory[]>] {
  const merchant = useMerchant();

  const [inventories, setInventories] = useState<CreateTaskInventory[]>([]);

  useEffect(() => {
    if (!merchant) {
      return;
    }

    setInventories([
      {
        external_id: faker.random.number().toString(),
        original_quantity: 1,
        services_external_ids: [],
        name: 'iPhone 12 Pro 128Gb - Black',
        description:
          'The iPhone 12 Pro and iPhone 12 Pro Max are smartphones designed and marketed by Apple Inc. They are the flagship smartphones in the fourteenth generation of the iPhone, succeeding the iPhone 11 Pro and iPhone 11 Pro Max. They were announced on October 13, 2020, with the iPhone 12 Pro being released on October 23, 2020, and the iPhone 12 Pro Max on November 13, 2020. The devices were unveiled alongside the iPhone 12 and iPhone 12 Mini at an Apple Special Event at Apple Park in Cupertino, California on October 13, 2020.',
        image:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/IPhone_12_Pro_Gold.svg/440px-IPhone_12_Pro_Gold.svg.png',
        price: 699,
      },
      {
        services_external_ids: [],
        external_id: faker.random.number().toString(),
        original_quantity: 1,
        name: 'Apple AirPods Pro - no engraving',
        description:
          'AirPods Pro have been designed to deliver Active Noise Cancellation for immersive sound, Transparency mode so you can hear your surroundings, and a customizable fit for all-day comfort. Just like AirPods, AirPods Pro connect magically to your Apple devices. And they’re ready to use right out of the case.',
        image:
          'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/airpods-pro-engraving-202005?wid=564&hei=454&fmt=png-alpha&.v=1588629613046',
        price: 249,
      },
    ]);
  }, [merchant]);

  return [inventories, setInventories];
}
